// src/components/admin/RankSettingsEditor.js
import React, { useState } from 'react';

const RankSettingsEditor = ({ ranks, setRanks }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // 新規追加時は isGachaTarget (SR/SSR対象) は false
    const addRank = () => {
        const newId = 'rank_' + Date.now();
        setRanks([...ranks, { 
            id: newId, 
            name: '新規ランク', 
            icon: '⭐', 
            type: 'full', 
            priority: false,
            isGachaTarget: false 
        }]);
    };

    const updateRank = (index, key, value) => {
        const newRanks = [...ranks];
        newRanks[index][key] = value;
        setRanks(newRanks);
    };

    const removeRank = (index) => {
        if(window.confirm('このランクを削除しますか？')) {
            const newRanks = [...ranks];
            newRanks.splice(index, 1);
            setRanks(newRanks);
        }
    };

    return (
        <div style={{marginBottom:'20px', border:'1px solid #ddd', borderRadius:'8px', background:'white'}}>
            
            <div 
                onClick={() => setIsExpanded(!isExpanded)}
                style={{
                    padding: '15px',
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    cursor: 'pointer',
                    background: '#fcfcfc',
                    borderRadius: isExpanded ? '8px 8px 0 0' : '8px',
                    borderBottom: isExpanded ? '1px solid #eee' : 'none'
                }}
            >
                <label style={{fontSize:'16px', fontWeight:'bold', margin: 0, color:'#333', cursor:'pointer'}}>
                    👑 会員ランク設定
                </label>
                <span style={{fontSize:'14px', fontWeight:'bold', color:'#666'}}>
                    {isExpanded ? '▲ 閉じる' : '▼ 開く'}
                </span>
            </div>

            {isExpanded && (
                <div style={{ padding: '15px', paddingTop: '10px' }}>
                    <div style={{fontSize:'11px', color:'#666', marginBottom:'15px', lineHeight:'1.5', background:'#f9f9f9', padding:'10px', borderRadius:'6px', border:'1px solid #eee'}}>
                        ※ 上から順に優先適用されます。<br/>
                        ※ 「優先」はイベント予約、「🌟SR/SSR対象」はガチャの当たり枠設定です。<br/>
                        <span style={{color:'#1565c0', fontWeight:'bold'}}>※ チーム一覧(スタメン)には、一番上のランクが自動で表示されます。</span>
                    </div>

                    <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                        {ranks.map((rank, i) => (
                            <div key={i} style={{
                                background:'#fff', 
                                border:'1px solid #e0e0e0', 
                                borderRadius:'8px', 
                                padding:'10px 15px',
                                boxShadow:'0 1px 3px rgba(0,0,0,0.05)'
                            }}>
                                {/* 1段目: No, アイコン, ランク名 */}
                                <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                    <div style={{
                                        width:'20px', height:'20px', background:'#333', borderRadius:'50%', 
                                        display:'flex', alignItems:'center', justifyContent:'center', 
                                        fontSize:'10px', fontWeight:'bold', color:'white'
                                    }}>
                                        {i+1}
                                    </div>
                                    
                                    <input type="text" value={rank.id} readOnly style={{display:'none'}} />

                                    <div style={{flex:'0 0 45px'}}>
                                        <input 
                                            type="text" 
                                            value={rank.icon} 
                                            onChange={e=>updateRank(i, 'icon', e.target.value)} 
                                            style={{width:'100%', textAlign:'center', padding:'6px', borderRadius:'4px', border:'1px solid #ccc', boxSizing:'border-box', fontSize:'14px'}} 
                                            placeholder="絵" 
                                        />
                                    </div>

                                    <div style={{flex:'1'}}>
                                        <input 
                                            type="text" 
                                            value={rank.name} 
                                            onChange={e=>updateRank(i, 'name', e.target.value)} 
                                            style={{width:'100%', padding:'6px 8px', borderRadius:'4px', border:'1px solid #ccc', boxSizing:'border-box', fontSize:'14px'}} 
                                            placeholder="ランク名" 
                                        />
                                    </div>
                                </div>

                                {/* 2段目: スッキリ簡素化した設定項目 */}
                                <div style={{
                                    display:'flex', 
                                    flexWrap: 'wrap',
                                    alignItems:'center', 
                                    justifyContent:'space-between',
                                    gap:'10px', 
                                    paddingTop:'10px', 
                                    marginTop:'10px', 
                                    borderTop:'1px dashed #eee'
                                }}>
                                    <div style={{display:'flex', gap:'15px', alignItems:'center'}}>
                                        {/* 割引設定 */}
                                        <div style={{display:'flex', alignItems:'center', gap:'5px'}}>
                                            <span style={{fontSize:'11px', color:'#666'}}>割引:</span>
                                            <select 
                                                value={rank.type} 
                                                onChange={e=>updateRank(i, 'type', e.target.value)} 
                                                style={{padding:'4px', fontSize:'11px', borderRadius:'4px', border:'1px solid #ccc'}}
                                            >
                                                <option value="full">全額</option>
                                                <option value="half">半額</option>
                                                <option value="free">無料</option>
                                            </select>
                                        </div>

                                        {/* 優先権 */}
                                        <label style={{display:'flex', alignItems:'center', gap:'4px', cursor:'pointer'}}>
                                            {/* ★修正: e.target.value を e.target.checked に変更しました */}
                                            <input 
                                                type="checkbox" 
                                                checked={rank.priority || false} 
                                                onChange={e=>updateRank(i, 'priority', e.target.checked)} 
                                            />
                                            <span style={{fontSize:'11px', color: rank.priority ? '#e65100' : '#666', fontWeight: rank.priority ? 'bold' : 'normal'}}>優先予約</span>
                                        </label>

                                        {/* ガチャ特待生（旧チーム表示） */}
                                        <label style={{display:'flex', alignItems:'center', gap:'4px', cursor:'pointer'}}>
                                            <input 
                                                type="checkbox" 
                                                checked={rank.isGachaTarget || false} 
                                                onChange={e=>updateRank(i, 'isGachaTarget', e.target.checked)} 
                                            />
                                            <span style={{fontSize:'11px', color: rank.isGachaTarget ? '#d50000' : '#666', fontWeight: rank.isGachaTarget ? 'bold' : 'normal'}}>🌟 SR/SSR対象</span>
                                        </label>
                                    </div>

                                    {/* ★修正: No.1 (i === 0) の時は削除ボタンを表示しない */}
                                    {i > 0 && (
                                        <button 
                                            onClick={()=>removeRank(i)} 
                                            style={{
                                                background:'transparent', color:'#c62828', border:'1px solid #ffcdd2', 
                                                borderRadius:'4px', padding:'4px 8px', fontSize:'11px', cursor:'pointer'
                                            }}
                                        >
                                            🗑️ 削除
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <button 
                        onClick={addRank} 
                        className="btn btn-primary"
                        style={{
                            width:'100%', marginTop:'15px', padding:'10px', 
                            background: '#f5f5f5', color: '#333', border: '1px dashed #ccc', borderRadius: '6px', 
                            fontSize: '12px', fontWeight: 'bold', cursor: 'pointer'
                        }}
                    >
                        + ランクを追加
                    </button>
                </div>
            )}
        </div>
    );
};

export default RankSettingsEditor;